import React, { useState, useRef ,useEffect } from 'react';
import axios from 'axios';
import Footer from './Components/Footer';
import About from './Components/About';


function App() {

  const [hindiSentence, setHindiSentence] = useState('');
  const [predictedBundeliWords, setPredictedBundeliWords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sloading, setSLoading] = useState(false);
  const [error, setError] = useState('');
  const audioRef = useRef(null);
 

  const handleInputChange = (e) => {
    setHindiSentence(e.target.value);
  };








  
  const handlePredictClick = async () => {
    if (!hindiSentence.trim()) {
      setError('Please enter a Hindi sentence.');
      return;
    }

    try {
      setLoading(true);
      setError('');

      setPredictedBundeliWords([]);

      const words = hindiSentence.split(/\s+/); // Split sentence into words

      for (const hindiWord of words) {
        const response = await axios.post('https://bundeli4back.azurewebsites.net/predict', {
          hindiSentence: hindiWord,
        });

        const predictedBundeliWord = response.data.predictedBundeliSentence;
        setPredictedBundeliWords((prevWords) => [...prevWords, predictedBundeliWord]);

        // Simulate a pause between words (adjust as needed)
        await new Promise(resolve => setTimeout(resolve, 20));
      }
    } catch (error) {
      console.error('Prediction failed:', error.message);
      setError('Prediction failed. Please try again.');
    } finally {
      setLoading(false);
      setSLoading(false); // Stop speaking loading indicator
    }
  };

  const handleSpeak = async () => {
    try {
      if (sloading) {
        // If already speaking, stop the playback
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
        setSLoading(false);
        return;
      }
  
      setSLoading(true); // Start speaking loading indicator
  
      const response = await axios.post('https://bundeli4back.azurewebsites.net/text-to-speech', {
        text: predictedBundeliWords.join(' '),
        language: 'hi',
      }, { responseType: 'blob' });
  
      const blob = new Blob([response.data], { type: 'audio/mpeg' });
      const audioUrl = URL.createObjectURL(blob);
  
      // Create or reuse the audio element
      if (!audioRef.current) {
        audioRef.current = new Audio(audioUrl);
      } else {
        audioRef.current.src = audioUrl;
      }
  
      // Update sLoading when the audio playback ends
      audioRef.current.onended = () => {
        setSLoading(false); // Stop speaking loading indicator
      };
  
      // Play the audio
      audioRef.current.play();
    } catch (error) {
      console.error('Text-to-speech request failed:', error.message);
      alert('Text-to-speech request failed. Please try again.');
      setSLoading(false); // Stop speaking loading indicator on error
    }
  };
  const [displayedText, setDisplayedText] = useState('');
  const fullText = 'बुंदेली तकता : A Place of Bundeli';

  useEffect(() => {
    let index = 0;
    const intervalId = setInterval(() => {
      setDisplayedText(fullText.slice(0, index));
      index++;
      if (index > fullText.length) {
        clearInterval(intervalId);
      }
    }, 50); // Adjust the interval as needed

    return () => {
      clearInterval(intervalId); // Cleanup on component unmount
    };
  }, []);

  return (
    <div className="container justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
       
      <div className="text-center mb-3" style={{ height: '70px' }}>
       
     
      <h3
        className="mb-1"
        style={{
          padding: '5px',
          height: '55px',
          color: 'white',
          background: '#343a40',
        }}
      >
        {displayedText}
      </h3>
      </div>
      
      <div className="card p-8">
        <div className="mb-3">
          <label htmlFor="hindiSentence" className="form-label">
            Enter Hindi (हिंदी) Sentence:
          </label>
          <textarea
            id="hindiSentence"
            placeholder="कृपया अपना हिंदी वाक्य लिखें..."
            className="form-control"
            style={{ border: '2px solid' ,maxWidth:'1150px', minHeight: '190px', height: 'auto'}}
            value={hindiSentence}
            onChange={handleInputChange}
            rows={9} // Limit to 10 lines
          />
        </div>
        <div className="text-center mb-3">
          <button
            onClick={handlePredictClick}
            className="btn btn-info bold-text"
            disabled={loading}
            style={{
              margin: '5px',
              width: '130px',
              padding: '3px',
              color: 'black',
              font: 'bold',
              height: '40px',
            }}
          >
            {loading ? 'Predicting...' : 'Predict Bundeli'}
          </button>
          <button
            onClick={handleSpeak}
            className="btn btn-warning ms-2 bold-text"
            disabled={!predictedBundeliWords.length || sloading}
            style={{ margin: '5px', width: '130px', padding: '3px', color: 'black', height: '40px' }}
          >
            {sloading ? 'Speaking..' : 'Speak (बुंदेलखंडी)'}
          </button>
        </div>
        {error && <p className="text-danger mt-3">{error}</p>}
        <div className="mt-4" style={{ minHeight: '190px', height: 'auto' }}>
          <h3>Bundeli (बुंदेलखंडी) Sentence:</h3>
          <p>{predictedBundeliWords.join(' ')}</p>
        </div>
        
      </div>
      <About/>
      
      <Footer />
    </div>
  );
}

export default App;
